import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const CompleteContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  background-color: ${COLORS.bgWhite};
`

export const CompleteScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const CompleteBottomBar = styled.div`
  flex: 0 0 auto;
  padding: 12px 24px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`

export const CompleteHeadingSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 60px 16px 12px;
`

export const CompleteHeading = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.42px;
  color: ${COLORS.textPrimary};
  text-align: center;
`

export const CompleteSubheading = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.textPrimary};
  text-align: center;

  & strong {
    font-weight: 600;
  }
`

export const CompleteImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
`

export const CompleteImage = styled.img`
  width: 200px;
  height: auto;
`

export const NoticeList = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 12px 12px 24px;
`

export const NoticeItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const NoticeIconBox = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background-color: #efefef;
`

export const NoticeIcon = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
`

export const NoticeTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const NoticeTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textPrimary};
`

export const NoticeDesc = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.textSecondary};
`
